/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Headers } from './headers';

export class RequestParams {
  /**
   * Endpoint Url to post/get
   */
  public url: string;

  /**
   * Ajax method to use
   * Can be either 'get' or 'post'
   */
  public method: string;

  /**
   * Http port
   */
  public port: number;

  /**
   * Available queryParams
   * @type {{}}
   */
  public queryParams: { [key: string]: string };

  /**
   * Headers to use
   * @type {{Content-Type: string}}
   */
  public headers: Headers;

  /**
   * Body for post
   * @type {{}}
   */
  public body: Object;

  /**
   * form for post
   * @type {{}}
   */
  public form: Object;

  // /**
  //  * json for post
  //  * @type boolean
  //  */
  // public json: boolean = true;

  // /**
  //  * gzip for post
  //  * @type boolean
  //  */
  // public gzip: boolean = false;

  constructor(url: string, method: string, body: Object = null, headers: Headers = {}) {
    this.url = url;
    this.method = method.toUpperCase();
    this.body = body;
    this.headers = headers;
  }
}
